import { render, staticRenderFns } from "./SidebarNavItem.vue?vue&type=template&id=7ed4d885&"
import script from "./SidebarNavItem.vue?vue&type=script&lang=js&"
export * from "./SidebarNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports